import { useContext } from "react";
import { GraduationCap, Question } from "@phosphor-icons/react";
import { ComponentsIcon, WidgetsIcon } from "../../Icons";
import { NavGroup } from "./NavGroup";
import { NavSection } from "./NavSection";
import { SupportSectionNavGroupsProps } from "./types";
import { AppContext } from "@/AppContext";

export const SupportSectionNavGroups: React.FC<
  SupportSectionNavGroupsProps
> = ({ doToggle = () => null, openNavGroups = {}, type = "default" }) => {
  // Read permissions the same way the rest of the Layout does (e.g. ClientSwitcher
  // gating in LeftSidebar). Agent-tier users get a stripped-down nav — Launch Pad
  // and Help Center are platform features that should not surface for them.
  const { permissions = [] } = useContext(AppContext);
  const isAgent = permissions?.includes("agents");

  return (
    <div data-testid="SupportSectionNavGroups">
      {/* Render the "Support" section */}
      {type === "default" && <NavSection>Support</NavSection>}

      {/* Launch Pad + Help Center are platform-only — hidden for agent-tier users,
          rendered for everyone else. */}
      {!isAgent && (
        <>
          {/* Render the "Launch Pad" menu item */}
          <NavGroup
            key="Launchpad"
            name="Launch Pad"
            href="/launchpad"
            icon={<WidgetsIcon />}
            type={type}
          />
          <NavGroup
            key="Help"
            name="Help Center"
            href="https://support.launchos.com/hc/launch-os-help-center/en"
            icon={<Question className="text-xl" />}
            type={type}
          />
        </>
      )}

      {/* Render the "University" menu item */}
      {/* <NavGroup
        key="university"
        name="University"
        href="https://university.tenminutefunnels.com"
        icon={<GraduationCap className="text-[22px]" />}
      /> */}

      {/* Render the "Sandcastle" menu item */}
      {/* <NavGroup
        key="sandcastle"
        name="Sandcastle"
        href="/sandcastle"
        icon={<ComponentsIcon />} /> */}

      {/* Render the "User Interface" menu item */}
      {/* <NavGroup
        key="ui"
        name="User Interface"
        icon={<WidgetsIcon />}
        isOpen={openNavGroups["ui"]}
        onClick={() => doToggle("ui")}
        items={[
          { href: "/ui/components", label: "Components" },
          { href: "/ui/elements", label: "Elements" },
          { href: "/ui/charts", label: "Charts" },
          { href: "/ui/widgets", label: "Widgets" },
          { href: "/ui/icons", label: "Icons & Modals" },
          { href: "/ui/dragdrop", label: "Drag & Drop" },
          { href: "/ui/tables", label: "Tables" },
          { href: "/ui/forms", label: "Forms" },
          { href: "/ui/pages", label: "Pages" },
        ]}
      /> */}
    </div>
  );
};
